module.exports = __webpack_public_path__ + "static/bg.e247daad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/research/bg.svg
// module id = 435
// module chunks = 168707334958949